import { useEffect, useRef, useCallback } from "react";

const useInactivityLogout = (
  logoutFunction,
  showNotificationFunction,
  timeoutMinutes = 15
) => {
  const timeoutRef = useRef(null);
  const TIMEOUT_DURATION = timeoutMinutes * 60 * 1000; // Convertir minutos a milisegundos

  const executeLogout = useCallback(async () => {
    try {
      if (logoutFunction && typeof logoutFunction === "function") {
        await logoutFunction();
      }

      if (
        showNotificationFunction &&
        typeof showNotificationFunction === "function"
      ) {
        showNotificationFunction();
      }
    } catch (error) {
      console.error("Error durante el logout automático:", error);
      if (
        showNotificationFunction &&
        typeof showNotificationFunction === "function"
      ) {
        showNotificationFunction();
      }
    }
  }, [logoutFunction, showNotificationFunction]);

  const resetTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      executeLogout();
    }, TIMEOUT_DURATION);
  }, [executeLogout, TIMEOUT_DURATION]);

  useEffect(() => {
    // Eventos que indican actividad del usuario
    const activityEvents = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
      "keydown",
    ];

    const handleUserActivity = () => {
      resetTimeout();
    };

    activityEvents.forEach((event) => {
      document.addEventListener(event, handleUserActivity, true);
    });

    resetTimeout();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      activityEvents.forEach((event) => {
        document.removeEventListener(event, handleUserActivity, true);
      });
    };
  }, [resetTimeout]);

  const resetTimer = useCallback(() => {
    resetTimeout();
  }, [resetTimeout]);

  return {
    resetTimer,
  };
};

export default useInactivityLogout;
